import { Stack, Typography } from '@mui/material';

type IFooterProps = {
  name: string;
  version: string;
  copy?: string;
};

function Footer(props: IFooterProps) {
  const { name, version, copy = '&copy; Applica Software Guru for' } = props;
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      flexGrow={1}
      height="auto"
      sx={{ pt: 1 }}
    >
      <Typography variant="caption">
        <span dangerouslySetInnerHTML={{ __html: copy || '' }} /> {name} - {version}
      </Typography>
    </Stack>
  );
}

export { Footer };
